module.exports = __webpack_public_path__ + "static/CloudBattery-1-dark-06368d043ee454da9584a53ade6eea48.svg";